// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f837df75","455":"9426a15c","977":"8bcc38ed"}[chunkId] + ".chunk.js";
};